import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import '../Admin/Admin.css';
import CollapseCard from '../CollapseCard/CollapseCard';
import TrainingEvents from './TrainingEvents.js';

class TrainingContainer extends Component {
    constructor(props) {
        super(props);

        this.blankTrainingEvent = {
            date: String(new Date().toISOString()).substring(0, 10),
            trainerName: '',
            topic: '',
            topicDetails: '',
            employees: []
        }
        this.state = {
            trainingEvents: [],
            trainingEventId: 0,
            editTrainingEvent: { ...this.blankTrainingEvent },
            newTrainingEvent: { ...this.blankTrainingEvent },
            employees: [],
            isLoaded: false,
        };
    }

    componentDidMount() {
        this.props.log('TrainingContainer.js/componentDidMount');
        this.getTrainingEvents();
        this.getEmployees();
    }

    getEmployees = () => {
        this.props.log('Client.js/getEmployees');
        fetch('/api/employees/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (this.isUnmounted) return;
                if (results.success) {
                    this.setState({
                        employees: results.data
                            .filter(employee => employee.active)
                            .map(employee => {
                                return ({
                                    employeeId: employee.employeeId,
                                    firstName: employee.firstName,
                                    lastName: employee.lastName
                                })
                            })
                            .sort((a,b) => a.lastName.localeCompare(b.lastName))
                    });
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    getTrainingEvents = () => {
        this.props.log('TrainingContainer.js/getTrainingEvents');
        fetch('/api/training-events/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (this.isUnmounted) return;
                if (results.success) {
                    this.setState({
                        trainingEvents: results.data,
                        isLoaded: true
                    });
                } else {
                    this.props.addToast('Unable to load events.', 5, 'danger');
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    onEditTrainingEvent = (trainingEventId) => {
        this.props.log('TrainingContainer.js/onEditTrainingEvent (trainingEventId)', trainingEventId);
        const trainingEvent = [...this.state.trainingEvents].filter(item => item.trainingEventId === trainingEventId)[0];
        this.setState(() => {
            return {
                editTrainingEvent: {
                    trainingEventId: trainingEvent.trainingEventId,
                    date: trainingEvent.date,
                    trainerName: trainingEvent.trainerName,
                    topic: trainingEvent.topic,
                    topicDetails: trainingEvent.topicDetails,
                    employees: trainingEvent.employees != null ? trainingEvent.employees : []
                }
            }
        })
    }

    onDeleteTrainingEvent = (trainingEventId) => {
        this.props.log('TrainingContainer.js/onDeleteTrainingEvent (trainingEventId)', trainingEventId);
        fetch('/api/training-events/' + trainingEventId, {
            method: 'DELETE',
            body: JSON.stringify({
                user: this.props.user
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.getTrainingEvents();
                    this.props.addToast('Event deleted successfully.', 5, 'success')
                } else {
                    this.props.addToast('Unable to delete event.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    onChangeTrainingEvent = (e, type) => {
        this.props.log('TrainingContainer.js/onChangeTrainingEvent (e, type)', e, type);
        e.persist();
        let thisTrainingEvent = (type === 'edit') ? this.state.editTrainingEvent : this.state.newTrainingEvent;
        switch (e.target.name) {
            case "employees":
                const employeeId = parseInt(String(e.target.id).split('_')[1]);
                const index = thisTrainingEvent.employees.findIndex(item => item === employeeId);
                if (index > -1) thisTrainingEvent.employees.splice(index, 1);
                if (e.target.checked) thisTrainingEvent.employees.push(employeeId);
                break;
            default:
                thisTrainingEvent[e.target.name] = e.target.value;
        }
        this.setState(() => {
            return (type === 'edit') ? { editTrainingEvent: thisTrainingEvent } : { newTrainingEvent: thisTrainingEvent };
        });
    }

    handleCancelTrainingEvent = () => {
        this.props.log('TrainingContainer.js/handleCancelTrainingEvent');
        this.setState({
            editTrainingEvent: { ...this.blankTrainingEvent },
        })
    }

    handleAddTrainingEvent = (e) => {
        this.props.log('TrainingContainer.js/handleAddTrainingEvent');
        fetch('/api/training-events/', {
            method: 'POST',
            body: JSON.stringify({
                date: this.state.newTrainingEvent.date,
                trainerName: this.state.newTrainingEvent.trainerName,
                topic: this.state.newTrainingEvent.topic,
                topicDetails: this.state.newTrainingEvent.topicDetails,
                user: this.props.user,
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (parseInt(results.data) > 0) {
                    this.setState({
                        newTrainingEvent: { ...this.blankTrainingEvent },
                    }, () => this.getTrainingEvents());
                    this.props.addToast('Event added successfully.', 5, 'success')
                } else {
                    this.props.addToast('Unable to add event.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    handleEditTrainingEvent = () => {
        this.props.log('TrainingContainer.js/handleEditTrainingEvent');
        fetch('/api/training-events/' + this.state.editTrainingEvent.trainingEventId, {
            method: 'PUT',
            body: JSON.stringify({
                date: this.state.editTrainingEvent.date,
                trainerName: this.state.editTrainingEvent.trainerName,
                topic: this.state.editTrainingEvent.topic,
                topicDetails: this.state.editTrainingEvent.topicDetails,
                employees: this.state.editTrainingEvent.employees,
                user: this.props.user
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        editTrainingEvent: { ...this.blankTrainingEvent },
                    }, () => this.getTrainingEvents());
                    this.props.addToast('Event updated successfully.', 5, 'success')
                } else {
                    this.props.addToast('Unable to update event.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    render() {
        this.props.info('TrainingContainer.js/render');
        return (
            (this.state.isLoaded) ?
                <>
                    <CollapseCard title="Training Events" open={true}>
                        <TrainingEvents
                            {...this.props}
                            trainingEvents={this.state.trainingEvents}
                            employees={this.state.employees}
                            newTrainingEvent={this.state.newTrainingEvent}
                            editTrainingEvent={this.state.editTrainingEvent}
                            onChange={this.onChangeTrainingEvent}
                            onEdit={this.onEditTrainingEvent}
                            onDelete={this.onDeleteTrainingEvent}
                            handleAdd={this.handleAddTrainingEvent}
                            handleEdit={this.handleEditTrainingEvent}
                            handleCancel={this.handleCancelTrainingEvent}
                            log={this.props.log}
                            info={this.props.info}
                        />
                    </CollapseCard>
                </>
                :
                <h3>Loading...</h3>
        );

    }
}

export default TrainingContainer;
